<template>
<div class="container fluid" id="fees">
<div class="row">
<div class="col-md-12">
<h3>Fee Items</h3>
<table>
<td><span>Monthly Finance Charge:</span></td>
<td>2.00%</td>
<tr>
<td><span>Late Fee:</span></td>
<td>15.00% Grace Days: 0</td>
</tr>
<tr>
<td><span>Restructure Fee:</span></td>
<td>$25.00</td>
</tr>
<tr>
<td><span>Property Tax Filing Fee:</span></td>
<td>$55.00</td>
</tr>
<tr>
<td><span>Insurance Surcharge:</span></td>
<td>$0.00</td>
</tr>
<tr>
<td><span>Insurance Surcharge Cap:</span></td>
<td>$350.00</td>
</tr>
<tr>
<td><span>One-time Payment Change Fee:</span></td>
<td>$25.00</td>
</tr>
<tr>
<td><span>Permanent Payment Change Fee:</span></td>
<td>$25.00</td>
</tr>
<tr>
<td><span>Account Closed Fee:</span></td>
<td>$100.00</td>
</tr>
<tr>
<td><span>Termination Fee:</span></td>
<td>$95.00</td>
</tr>
</table>
</div>
</div>
</div>
</template>

<script>
export default {
  name: 'modalFees',
  components: {
  },
  props: {
    parentData: {
      type: Number
    }
  },
  data: function () {
    return {
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style>
#fees span {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/modalFees.vue